import { useCallback } from "react";
import { useAuth } from "../../../hooks";
export var useAnnouncements = function(key, hasAnnouncement) {
    var accountId = useAuth().accountId;
    var dismissKey = "vch.".concat(key, "_").concat(accountId);
    var isAcknowledged = Boolean(sessionStorage.getItem(dismissKey));
    var setAcknowledged = useCallback(function() {
        return hasAnnouncement && sessionStorage.setItem(dismissKey, "true");
    }, [
        dismissKey,
        hasAnnouncement
    ]);
    return {
        isAcknowledged: isAcknowledged,
        setAcknowledged: setAcknowledged
    };
};

//# sourceMappingURL=useAnnouncements.js.map